import {
	GET_CONVERSATION_SILENCE,
	RESET_CONVERSATION_SILENCE,
} from './action-types';
import { ErrorEventEnum } from '../../lib/enums';
import { ErrorEventNameMap } from '../../lib/names-utils';

const {
	SILENCE_EVENT,
} = ErrorEventEnum;

export function getConversationSilenceAction(blockTo, message) {
	return {
		type: GET_CONVERSATION_SILENCE,
		blockTo,
		message: message || ErrorEventNameMap[SILENCE_EVENT],
	};
}

export function resetConversationSilenceAction() {
	return {
		type: RESET_CONVERSATION_SILENCE,
	};
}
